__turbopack_context__.v({
  "anchor": "CNestedCatalogs-module__tI63jq__anchor",
  "element": "CNestedCatalogs-module__tI63jq__element",
  "elementInner": "CNestedCatalogs-module__tI63jq__elementInner",
  "empty": "CNestedCatalogs-module__tI63jq__empty",
  "label": "CNestedCatalogs-module__tI63jq__label",
  "list": "CNestedCatalogs-module__tI63jq__list",
  "wrap": "CNestedCatalogs-module__tI63jq__wrap",
});
